import { LibraryIcon } from "@heroicons/react/outline";

export const PlanCardLoading = () => (
  <div className="max-w-[600px] rounded-2xl border border-gray-200 bg-white">
    <div className="px-6 py-4">
      <div className="space-y-3">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500 to-blue-600">
            <LibraryIcon className="h-5 w-5 text-white" />
          </div>
          <div>
            <div className="h-5 w-20 animate-pulse rounded bg-gray-200" />
            <div className="mt-1 h-4 w-32 animate-pulse rounded bg-gray-200" />
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="h-6 w-20 animate-pulse rounded-full bg-gray-200" />
          <div className="h-6 w-16 animate-pulse rounded-full bg-gray-200" />
        </div>
      </div>
    </div>
  </div>
);
